import { render, staticRenderFns } from "./TiCertificadosItau.vue?vue&type=template&id=0c090972&scoped=true"
import script from "./TiCertificadosItau.vue?vue&type=script&lang=js"
export * from "./TiCertificadosItau.vue?vue&type=script&lang=js"
import style0 from "./TiCertificadosItau.vue?vue&type=style&index=0&id=0c090972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c090972",
  null
  
)

export default component.exports